<template>
  <v-card
    class="d-flex flex-column justify-center align-center"
    style="min-height: 400px; "
  >
    <div
      class="d-flex flex-column align-center justify-center"
      style="max-width: 290px"
    >
      <v-icon size="32" color="blue-grey lighten-1" class="mb-3"
        >mdi-ghost-outline</v-icon
      >
      <p class="ma-0 pa-0 subtitle-2 blue-grey--text text--darken-1 mb-1">
        {{ $t('insights.filters_not_matching_title') }}
      </p>
      <p class="ma-0 pa-0 caption blue-grey--text text-center">
        {{ $t('insights.filters_not_matching_subtitle') }}
      </p>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'EmptyState',
}
</script>
